import React, { useState } from 'react';
import { 
  BarChart3,
  PieChart,
  LineChart,
  TrendingUp,
  TrendingDown,
  DollarSign,
  CreditCard,
  Calculator,
  FileText,
  Eye,
  Trash2,
  Edit,
  Save,
  X,
  Plus,
  Search,
  Filter,
  MoreHorizontal,
  Bookmark,
  Star,
  Share,
  Info,
  ExternalLink,
  Archive,
  Send,
  Flag,
  Heart,
  ThumbsUp,
  ThumbsDown,
  Upload,
  FileUp,
  FileDown,
  FileCheck,
  FileX,
  Volume2,
  VolumeX,
  Headphones,
  Speaker,
  Radio,
  Music,
  Video,
  Camera,
  Image,
  File,
  Folder,
  FolderOpen,
  HardDrive,
  Cloud,
  Wifi,
  WifiOff,
  Signal,
  Battery,
  BatteryLow,
  Power,
  PowerOff,
  Activity,
  Zap,
  Shield,
  Lock,
  Key,
  Users,
  Building,
  Calendar,
  Phone,
  Mail,
  MapPin,
  CheckSquare,
  Square as SquareIcon,
  ArrowUpRight,
  ArrowDownRight,
  ArrowLeft,
  Home,
  Wrench,
  FileBarChart,
  Cog,
  Settings,
  Link,
  Monitor,
  Tablet,
  Smartphone,
  Lightbulb,
  Cpu,
  Network,
  Database,
  Layers,
  User,
  Languages,
  Mic,
  Play,
  Pause,
  Square,
  RefreshCw,
  Copy,
  Download,
  Globe,
  Users2,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Clock,
  Target,
  Brain,
  MessageSquare,
  AlertCircle,
  CheckSquare as CheckSquareIcon,
  Receipt,
  Bot,
  Scan,
  Zap as ZapIcon,
  Shield as ShieldIcon,
  AreaChart,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  ArrowUp,
  ArrowDown,
  Minus,
  Percent,
  Calendar as CalendarIcon,
  Clock as ClockIcon,
  AlertCircle as AlertCircleIcon,
  Info as InfoIcon,
  Lightbulb as LightbulbIcon,
  Award,
  Gift,
  Coins,
  Wallet,
  PiggyBank,
  Banknote,
  Receipt as ReceiptIcon,
  ShoppingCart,
  Package,
  Truck,
  Building2,
  Factory,
  Store,
  Home as HomeIcon,
  Car,
  Plane,
  Train,
  Ship,
  Fuel,
  Wrench as WrenchIcon,
  Tool,
  Hammer,
  Screwdriver,
  Cog as CogIcon,
  Settings as SettingsIcon,
  BarChart,
  PieChart as PieChartIcon,
  Activity as ActivityIcon,
  Zap as ZapIcon2,
  Target as TargetIcon,
  Brain as BrainIcon,
  Database as DatabaseIcon,
  Layers as LayersIcon,
  Network as NetworkIcon,
  Cpu as CpuIcon,
  Monitor as MonitorIcon,
  Smartphone as SmartphoneIcon,
  Tablet as TabletIcon,
  Globe as GlobeIcon,
  Users as UsersIcon,
  Building as BuildingIcon,
  Home as HomeIcon2,
  Car as CarIcon,
  Plane as PlaneIcon,
  Train as TrainIcon,
  Ship as ShipIcon,
  Truck as TruckIcon,
  Package as PackageIcon,
  ShoppingCart as ShoppingCartIcon,
  Receipt as ReceiptIcon2,
  Banknote as BanknoteIcon,
  PiggyBank as PiggyBankIcon,
  Wallet as WalletIcon,
  Coins as CoinsIcon,
  Gift as GiftIcon,
  Award as AwardIcon,
  Lightbulb as LightbulbIcon2,
  Info as InfoIcon2,
  AlertCircle as AlertCircleIcon2,
  Clock as ClockIcon2,
  Calendar as CalendarIcon2,
  Percent as PercentIcon,
  Minus as MinusIcon,
  ArrowDown as ArrowDownIcon,
  ArrowUp as ArrowUpIcon,
  TrendingDown as TrendingDownIcon2,
  TrendingUp as TrendingUpIcon2,
  AreaChart as AreaChartIcon,
  Shield as ShieldIcon2,
  Scan as ScanIcon,
  Bot as BotIcon,
  CheckSquare as CheckSquareIcon2,
  MessageSquare as MessageSquareIcon2,
  Brain as BrainIcon2,
  Target as TargetIcon2,
  Zap as ZapIcon3,
  Activity as ActivityIcon2,
  BarChart as BarChartIcon,
  PieChart as PieChartIcon2,
  LineChart as LineChartIcon,
  TrendingDown as TrendingDownIcon3,
  TrendingUp as TrendingUpIcon3,
  Calculator as CalculatorIcon,
  CreditCard as CreditCardIcon,
  DollarSign as DollarSignIcon,
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Trash2 as Trash2Icon,
  Edit as EditIcon,
  Save as SaveIcon,
  X as XIcon,
  Plus as PlusIcon,
  Search as SearchIcon,
  Filter as FilterIcon,
  MoreHorizontal as MoreHorizontalIcon,
  Bookmark as BookmarkIcon,
  Star as StarIcon,
  Share as ShareIcon,
  Info as InfoIcon3,
  ExternalLink as ExternalLinkIcon,
  Archive as ArchiveIcon,
  Send as SendIcon,
  Flag as FlagIcon,
  Heart as HeartIcon,
  ThumbsUp as ThumbsUpIcon,
  ThumbsDown as ThumbsDownIcon,
  Upload as UploadIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  Volume2 as Volume2Icon,
  VolumeX as VolumeXIcon,
  Headphones as HeadphonesIcon,
  Speaker as SpeakerIcon,
  Radio as RadioIcon,
  Music as MusicIcon,
  Video as VideoIcon,
  Camera as CameraIcon,
  Image as ImageIcon,
  File as FileIcon,
  Folder as FolderIcon,
  FolderOpen as FolderOpenIcon,
  HardDrive as HardDriveIcon,
  Cloud as CloudIcon,
  Wifi as WifiIcon,
  WifiOff as WifiOffIcon,
  Signal as SignalIcon,
  Battery as BatteryIcon,
  BatteryLow as BatteryLowIcon,
  Power as PowerIcon,
  PowerOff as PowerOffIcon,
  Activity as ActivityIcon3,
  Zap as ZapIcon4,
  Shield as ShieldIcon3,
  Lock as LockIcon,
  Key as KeyIcon,
  Users as UsersIcon2,
  Building as BuildingIcon2,
  Calendar as CalendarIcon3,
  Phone as PhoneIcon,
  Mail as MailIcon,
  MapPin as MapPinIcon,
  CheckSquare as CheckSquareIcon3,
  Square as SquareIcon2,
  ArrowUpRight as ArrowUpRightIcon,
  ArrowDownRight as ArrowDownRightIcon,
  ArrowLeft as ArrowLeftIcon,
  Home as HomeIcon3,
  Wrench as WrenchIcon2,
  FileBarChart as FileBarChartIcon,
  Cog as CogIcon2,
  Settings as SettingsIcon2,
  Link as LinkIcon,
  Monitor as MonitorIcon2,
  Tablet as TabletIcon2,
  Smartphone as SmartphoneIcon2,
  Lightbulb as LightbulbIcon3,
  Cpu as CpuIcon2,
  Network as NetworkIcon2,
  Database as DatabaseIcon2,
  Layers as LayersIcon2,
  User as UserIcon,
  Languages as LanguagesIcon,
  Mic as MicIcon,
  Play as PlayIcon,
  Pause as PauseIcon,
  Square as SquareIcon3,
  RefreshCw as RefreshCwIcon,
  Copy as CopyIcon,
  Download as DownloadIcon,
  Globe as GlobeIcon2,
  Users2 as Users2Icon,
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  XCircle as XCircleIcon,
  Clock as ClockIcon3,
  Brain as BrainIcon3,
  AlertCircle as AlertCircleIcon3,
  CheckSquare as CheckSquareIcon4
} from 'lucide-react';
import DataTable from '../common/DataTable';
import ConfirmationModal from '../common/ConfirmationModal';

const Analytics = () => {
  const [activeTab, setActiveTab] = useState('financial');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  // Mock data for financial analytics
  const [financialAnalytics, setFinancialAnalytics] = useState([
    {
      id: 'FIN-001',
      metricName: 'Total Revenue',
      category: 'Revenue',
      currentValue: '$2,450,000',
      previousValue: '$2,200,000',
      change: '+$250,000',
      changePercentage: 11.4,
      trend: 'Up',
      period: 'Q1 2024',
      status: 'Active',
      confidence: 95.2,
      description: 'Total revenue generated across all business units',
      createdDate: '2024-02-15',
      lastUpdated: '2024-02-15',
      createdBy: 'AI System',
      department: 'Finance',
      isActive: true,
      tags: ['revenue', 'growth', 'quarterly'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 125,
      downloadCount: 15,
      aiInsights: ['Strong growth trajectory', 'Market expansion successful', 'Pricing optimization effective'],
      keyDrivers: ['New client acquisitions', 'Price increases', 'Market expansion'],
      forecast: '$2,650,000',
      riskFactors: ['Economic uncertainty', 'Competition pressure']
    },
    {
      id: 'FIN-002',
      metricName: 'Operating Expenses',
      category: 'Expenses',
      currentValue: '$1,890,000',
      previousValue: '$1,950,000',
      change: '-$60,000',
      changePercentage: -3.1,
      trend: 'Down',
      period: 'Q1 2024',
      status: 'Active',
      confidence: 92.8,
      description: 'Total operating expenses including salaries, rent, and utilities',
      createdDate: '2024-02-15',
      lastUpdated: '2024-02-15',
      createdBy: 'AI System',
      department: 'Finance',
      isActive: true,
      tags: ['expenses', 'cost-control', 'efficiency'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 98,
      downloadCount: 12,
      aiInsights: ['Cost optimization successful', 'Efficiency improvements noted', 'Budget management effective'],
      keyDrivers: ['Process automation', 'Vendor negotiations', 'Resource optimization'],
      forecast: '$1,820,000',
      riskFactors: ['Inflation pressure', 'Talent acquisition costs']
    },
    {
      id: 'FIN-003',
      metricName: 'Net Profit Margin',
      category: 'Profitability',
      currentValue: '22.9%',
      previousValue: '20.5%',
      change: '+2.4%',
      changePercentage: 11.7,
      trend: 'Up',
      period: 'Q1 2024',
      status: 'Active',
      confidence: 94.5,
      description: 'Net profit margin indicating operational efficiency',
      createdDate: '2024-02-15',
      lastUpdated: '2024-02-15',
      createdBy: 'AI System',
      department: 'Finance',
      isActive: true,
      tags: ['profitability', 'margin', 'efficiency'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 156,
      downloadCount: 18,
      aiInsights: ['Margin expansion successful', 'Operational efficiency improved', 'Revenue mix optimized'],
      keyDrivers: ['Revenue growth', 'Cost reduction', 'Product mix'],
      forecast: '24.2%',
      riskFactors: ['Market competition', 'Cost inflation']
    }
  ]);

  // Mock data for operational analytics
  const [operationalAnalytics, setOperationalAnalytics] = useState([
    {
      id: 'OPS-001',
      metricName: 'Contract Processing Time',
      category: 'Efficiency',
      currentValue: '3.2 days',
      previousValue: '4.8 days',
      change: '-1.6 days',
      changePercentage: -33.3,
      trend: 'Up',
      period: 'Q1 2024',
      status: 'Active',
      confidence: 91.7,
      description: 'Average time to process contracts from initiation to approval',
      createdDate: '2024-02-10',
      lastUpdated: '2024-02-12',
      createdBy: 'AI System',
      department: 'Operations',
      isActive: true,
      tags: ['efficiency', 'automation', 'process-improvement'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 87,
      downloadCount: 9,
      aiInsights: ['Automation impact significant', 'Process optimization successful', 'Bottlenecks eliminated'],
      keyDrivers: ['AI automation', 'Process redesign', 'Staff training'],
      forecast: '2.8 days',
      riskFactors: ['Complex contracts', 'Regulatory changes']
    },
    {
      id: 'OPS-002',
      metricName: 'Asset Utilization Rate',
      category: 'Utilization',
      currentValue: '87.3%',
      previousValue: '82.1%',
      change: '+5.2%',
      changePercentage: 6.3,
      trend: 'Up',
      period: 'Q1 2024',
      status: 'Active',
      confidence: 89.4,
      description: 'Percentage of assets actively utilized vs. total available',
      createdDate: '2024-02-08',
      lastUpdated: '2024-02-10',
      createdBy: 'AI System',
      department: 'Operations',
      isActive: true,
      tags: ['utilization', 'efficiency', 'asset-management'],
      isBookmarked: false,
      isStarred: true,
      viewCount: 73,
      downloadCount: 7,
      aiInsights: ['Asset optimization effective', 'Maintenance scheduling improved', 'Capacity planning successful'],
      keyDrivers: ['Maintenance optimization', 'Demand forecasting', 'Asset allocation'],
      forecast: '89.1%',
      riskFactors: ['Equipment aging', 'Demand volatility']
    },
    {
      id: 'OPS-003',
      metricName: 'Customer Satisfaction Score',
      category: 'Quality',
      currentValue: '4.7/5.0',
      previousValue: '4.4/5.0',
      change: '+0.3',
      changePercentage: 6.8,
      trend: 'Up',
      period: 'Q1 2024',
      status: 'Active',
      confidence: 93.1,
      description: 'Average customer satisfaction rating across all touchpoints',
      createdDate: '2024-02-05',
      lastUpdated: '2024-02-08',
      createdBy: 'AI System',
      department: 'Customer Success',
      isActive: true,
      tags: ['satisfaction', 'quality', 'customer-experience'],
      isBookmarked: true,
      isStarred: false,
      viewCount: 112,
      downloadCount: 14,
      aiInsights: ['Service quality improved', 'Response time optimized', 'Customer feedback positive'],
      keyDrivers: ['Service improvements', 'Response time', 'Product quality'],
      forecast: '4.8/5.0',
      riskFactors: ['Service expectations', 'Competition quality']
    }
  ]);

  // Calculate statistics
  const stats = {
    totalFinancialMetrics: financialAnalytics.length,
    totalOperationalMetrics: operationalAnalytics.length,
    positiveTrends: [...financialAnalytics, ...operationalAnalytics].filter(m => m.trend === 'Up').length,
    negativeTrends: [...financialAnalytics, ...operationalAnalytics].filter(m => m.trend === 'Down').length,
    averageConfidence: [...financialAnalytics, ...operationalAnalytics].reduce((sum, m) => sum + m.confidence, 0) / [...financialAnalytics, ...operationalAnalytics].length,
    highConfidenceMetrics: [...financialAnalytics, ...operationalAnalytics].filter(m => m.confidence >= 90).length,
    totalViews: [...financialAnalytics, ...operationalAnalytics].reduce((sum, m) => sum + m.viewCount, 0),
    totalDownloads: [...financialAnalytics, ...operationalAnalytics].reduce((sum, m) => sum + m.downloadCount, 0)
  };

  const tabs = [
    { id: 'financial', label: 'Financial Analytics' },
    { id: 'operational', label: 'Operational Analytics' },
    { id: 'predictive', label: 'Predictive Analytics' },
    { id: 'custom', label: 'Custom Reports' }
  ];

  // Define columns for Financial Analytics DataTable
  const financialColumns = [
    {
      key: 'metricName',
      label: 'Financial Metric Details',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.category} • {row.period} • {row.department}
          </div>
        </div>
      )
    },
    {
      key: 'currentValue',
      label: 'Current Value',
      width: '140px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{value}</span>
      )
    },
    {
      key: 'change',
      label: 'Change',
      width: '120px',
      render: (change, row) => (
        <span style={{ 
          fontWeight: '600', 
          color: row.trend === 'Up' ? '#10b981' : row.trend === 'Down' ? '#ef4444' : '#6b7280' 
        }}>
          {change}
        </span>
      )
    },
    {
      key: 'changePercentage',
      label: 'Change %',
      width: '100px',
      render: (percentage, row) => (
        <span style={{ 
          fontWeight: '500', 
          color: row.trend === 'Up' ? '#10b981' : row.trend === 'Down' ? '#ef4444' : '#6b7280' 
        }}>
          {percentage > 0 ? '+' : ''}{percentage.toFixed(1)}%
        </span>
      )
    },
    {
      key: 'trend',
      label: 'Trend',
      width: '100px',
      render: (trend) => {
        const trendConfig = {
          'Up': { color: '#10b981', bg: '#d1fae5', icon: <TrendingUp size={14} /> },
          'Down': { color: '#ef4444', bg: '#fee2e2', icon: <TrendingDown size={14} /> },
          'Stable': { color: '#6b7280', bg: '#f3f4f6', icon: <Minus size={14} /> }
        };
        const config = trendConfig[trend] || trendConfig['Stable'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {trend}
          </span>
        );
      }
    },
    {
      key: 'confidence',
      label: 'Confidence',
      width: '120px',
      render: (confidence) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${confidence}%`,
              height: '100%',
              backgroundColor: confidence >= 90 ? '#10b981' : confidence >= 80 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: confidence >= 90 ? '#10b981' : confidence >= 80 ? '#f59e0b' : '#ef4444' 
          }}>
            {confidence.toFixed(1)}%
          </span>
        </div>
      )
    },
    {
      key: 'forecast',
      label: 'Forecast',
      width: '120px',
      render: (forecast) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{forecast}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Data"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Metric"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Define columns for Operational Analytics DataTable
  const operationalColumns = [
    {
      key: 'metricName',
      label: 'Operational Metric Details',
      width: '300px',
      render: (value, row) => (
        <div>
          <div style={{ fontWeight: '500', color: '#1f2937', marginBottom: '4px' }}>{value}</div>
          <div style={{ fontSize: '12px', color: '#6b7280' }}>
            {row.category} • {row.period} • {row.department}
          </div>
        </div>
      )
    },
    {
      key: 'currentValue',
      label: 'Current Value',
      width: '140px',
      render: (value) => (
        <span style={{ fontWeight: '600', color: '#1f2937' }}>{value}</span>
      )
    },
    {
      key: 'change',
      label: 'Change',
      width: '120px',
      render: (change, row) => (
        <span style={{ 
          fontWeight: '600', 
          color: row.trend === 'Up' ? '#10b981' : row.trend === 'Down' ? '#ef4444' : '#6b7280' 
        }}>
          {change}
        </span>
      )
    },
    {
      key: 'changePercentage',
      label: 'Change %',
      width: '100px',
      render: (percentage, row) => (
        <span style={{ 
          fontWeight: '500', 
          color: row.trend === 'Up' ? '#10b981' : row.trend === 'Down' ? '#ef4444' : '#6b7280' 
        }}>
          {percentage > 0 ? '+' : ''}{percentage.toFixed(1)}%
        </span>
      )
    },
    {
      key: 'trend',
      label: 'Trend',
      width: '100px',
      render: (trend) => {
        const trendConfig = {
          'Up': { color: '#10b981', bg: '#d1fae5', icon: <TrendingUp size={14} /> },
          'Down': { color: '#ef4444', bg: '#fee2e2', icon: <TrendingDown size={14} /> },
          'Stable': { color: '#6b7280', bg: '#f3f4f6', icon: <Minus size={14} /> }
        };
        const config = trendConfig[trend] || trendConfig['Stable'];
        
        return (
          <span style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px 10px',
            borderRadius: '6px',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: config.bg,
            color: config.color,
            width: 'fit-content'
          }}>
            {config.icon}
            {trend}
          </span>
        );
      }
    },
    {
      key: 'confidence',
      label: 'Confidence',
      width: '120px',
      render: (confidence) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <div style={{
            width: '60px',
            height: '6px',
            backgroundColor: '#e5e7eb',
            borderRadius: '3px',
            overflow: 'hidden'
          }}>
            <div style={{
              width: `${confidence}%`,
              height: '100%',
              backgroundColor: confidence >= 90 ? '#10b981' : confidence >= 80 ? '#f59e0b' : '#ef4444',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <span style={{ 
            fontSize: '12px', 
            fontWeight: '500', 
            color: confidence >= 90 ? '#10b981' : confidence >= 80 ? '#f59e0b' : '#ef4444' 
          }}>
            {confidence.toFixed(1)}%
          </span>
        </div>
      )
    },
    {
      key: 'forecast',
      label: 'Forecast',
      width: '120px',
      render: (forecast) => (
        <span style={{ fontWeight: '500', color: '#007B8F' }}>{forecast}</span>
      )
    },
    {
      key: 'actions',
      label: 'Actions',
      width: '200px',
      render: (value, row) => (
        <div style={{ display: 'flex', gap: '6px' }}>
          <button
            onClick={() => handleView(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#007B8F',
              color: '#007B8F',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="View Details"
          >
            <Eye size={14} /> View
          </button>
          <button
            onClick={() => handleExport(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#10b981',
              color: '#10b981',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Export Data"
          >
            <Download size={14} /> Export
          </button>
          <button
            onClick={() => handleDelete(row)}
            style={{
              padding: '6px 10px',
              fontSize: '12px',
              borderRadius: '6px',
              borderColor: '#ef4444',
              color: '#ef4444',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              gap: '4px'
            }}
            title="Delete Metric"
          >
            <Trash2 size={14} /> Delete
          </button>
        </div>
      )
    }
  ];

  // Handler functions
  const handleView = (item) => {
    //console.log('Viewing item:', item.metricName);
  };

  const handleExport = (metric) => {
    setSelectedItem(metric);
    setShowExportModal(true);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      if (activeTab === 'financial') {
        setFinancialAnalytics(prev => prev.filter(metric => metric.id !== selectedItem.id));
      } else {
        setOperationalAnalytics(prev => prev.filter(metric => metric.id !== selectedItem.id));
      }
      setShowDeleteModal(false);
      setSelectedItem(null);
    } catch (error) {
      console.error('Error deleting item:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleExportConfirm = async () => {
    setIsProcessing(true);
    try {
      setShowExportModal(false);
      setSelectedItem(null);
      // Here you would typically export the data
    } catch (error) {
      console.error('Error exporting data:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{
      padding: '24px',
      fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
      backgroundColor: '#f8fafc',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{ marginBottom: '32px' }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 8px 0',
          background: 'linear-gradient(135deg, #007B8F 0%, #4A9BA8 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Analytics
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: 0
        }}>
          Comprehensive analytics dashboard with financial, operational, and predictive insights
        </p>
      </div>

      {/* Tabbed Navigation */}
      <div style={{ marginBottom: '32px' }}>
        <div style={{
          display: 'flex',
          borderBottom: '1px solid #e5e7eb',
          gap: '0'
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '12px 24px',
                color: activeTab === tab.id ? '#007B8F' : '#6b7280',
                borderBottom: activeTab === tab.id ? '3px solid #007B8F' : '3px solid transparent',
                transition: 'all 0.15s ease-in-out',
                fontWeight: '500',
                fontSize: '14px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
                position: 'relative',
                marginBottom: '-1px'
              }}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.id === 'financial' && <DollarSign size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'operational' && <Activity size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'predictive' && <Brain size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.id === 'custom' && <BarChart3 size={18} style={{ color: activeTab === tab.id ? '#007B8F' : '#9ca3af' }} />}
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Stats Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
        marginBottom: '32px'
      }}>
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Metrics</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.totalFinancialMetrics + stats.totalOperationalMetrics}
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.totalFinancialMetrics} financial, {stats.totalOperationalMetrics} operational
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#007B8F20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#007B8F'
          }}>
            <BarChart3 size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Positive Trends</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.positiveTrends}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.negativeTrends} negative trends
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#10b98120',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#10b981'
          }}>
            <TrendingUp size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Avg. Confidence</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>
              {stats.averageConfidence.toFixed(1)}%
            </h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.highConfidenceMetrics} high confidence metrics
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#f59e0b20',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#f59e0b'
          }}>
            <Target size={20} />
          </div>
        </div>

        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          border: '1px solid #e5e7eb'
        }}>
          <div>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 8px 0' }}>Total Views</p>
            <h2 style={{ fontSize: '28px', fontWeight: '700', color: '#1f2937', margin: 0 }}>{stats.totalViews}</h2>
            <p style={{ fontSize: '12px', color: '#6b7280', margin: '4px 0 0 0' }}>
              {stats.totalDownloads} downloads
            </p>
          </div>
          <div style={{
            width: '48px',
            height: '48px',
            borderRadius: '12px',
            backgroundColor: '#8b5cf620',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#8b5cf6'
          }}>
            <Eye size={20} />
          </div>
        </div>
      </div>

      {/* Financial Analytics Tab */}
      {activeTab === 'financial' && (
        <div>
          {/* Financial Analytics DataTable */}
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={financialAnalytics}
              columns={financialColumns}
              title={`Financial Analytics (${financialAnalytics.length} metrics)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Operational Analytics Tab */}
      {activeTab === 'operational' && (
        <div>
          {/* Operational Analytics DataTable */}
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <DataTable
              data={operationalAnalytics}
              columns={operationalColumns}
              title={`Operational Analytics (${operationalAnalytics.length} metrics)`}
              searchable={false}
              sortable={true}
              exportable={true}
              pagination={true}
              pageSize={10}
              hiddenColumns={['none']}
              onHiddenColumnsChange={() => {}}
            />
          </div>
        </div>
      )}

      {/* Other Tabs */}
      {activeTab === 'predictive' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Predictive Analytics Dashboard Coming Soon!
        </div>
      )}

      {activeTab === 'custom' && (
        <div style={{
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '20px',
          boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
          border: '1px solid #e5e7eb',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '18px',
          color: '#6b7280'
        }}>
          Custom Reports Builder Coming Soon!
        </div>
      )}

      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        title="Delete Metric"
        message={`Are you sure you want to delete "${selectedItem?.metricName}"? This action cannot be undone.`}
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={isDeleting}
      />

      {/* Export Data Modal */}
      <ConfirmationModal
        isOpen={showExportModal}
        onClose={() => setShowExportModal(false)}
        onConfirm={handleExportConfirm}
        title="Export Data"
        message={`Export data for "${selectedItem?.metricName}"? This will generate a downloadable report with historical data and insights.`}
        confirmText="Export"
        cancelText="Cancel"
        type="success"
        isLoading={isProcessing}
      />
    </div>
  );
};

export default Analytics;
